import styled, { css } from 'styled-components/macro';

export const LogoHolder = styled.div`
  flex-shrink: 0;
  width: 80px;

  @media (min-width: 576px) {
    width: 130px;
  }

  img {
    width: 100%;
    height: auto;

    &.logoWhite {
      display: block;

      .light & {
        display: none;
      }
    }
    &.logoBlack {
      display: none;

      .light & {
        display: block;
      }
    }
  }
`;

export const HeaderWrap = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 0 0 0 10px;
  margin: 0;

  @media (min-width: 576px) {
    padding: 0 0 0 15px;
  }
  @media (min-width: 992px) {
    padding: 0 0 0 118px;
  }

  h1 {
    display: none;
    margin: 0;

    @media (min-width: 768px) {
      display: block;
    }
  }
`;

export const RightCol = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  padding-left: 10px;
`;

export const SearchHolder = styled.div`
  padding: 0 10px;

  button {
    padding: 0;
  }

  .icon-search {
    font-size: 24px;
    line-height: 1;
    color: #5b5a99;
    display: none;
  }
`;
export const NoficationHolder = styled.div`
  display: inline-block;
  position: relative;
`;

export const Notification = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 30px;
  font-size: 12px;
  line-height: 15px;
  font-weight: 700;
  text-align: center;
  border-radius: 54px;
  mix-blend-mode: normal;
  box-shadow: 0px 5px 34px rgba(186, 19, 88, 0.42);
  background: linear-gradient(136.67deg, #ff409a 8.34%, #c438ef 95.26%);

  .icon-bell {
    display: inline-block;
    vertical-align: top;
    font-size: 13px;
    line-height: 1;
    margin: 1px 2px 0 0;
  }
`;

export const NotificationDropDown = styled.div`
  position: absolute;
  top: 100%;
  left: -78px;
  margin: 50px 0 0;
  /* visibility: hidden;
  opacity: 0; */
  width: 320px;
  padding: 20px 25px;
  font-size: 11px;
  line-height: 17px;
  border-radius: 20px;
  background: #25214f;
  box-shadow: 0px 8px 4px rgba(0, 0, 0, 0.25);

  &:before {
    content: '';
    height: 62px;
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 10px;
    background: linear-gradient(176.74deg, rgba(37, 33, 79, 0) 2.69%, #25214f 75.19%);
  }

  ${({ dropdownOpen }) =>
    dropdownOpen &&
    css`
      visibility: visible;
      opacity: 1;
    `}

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    margin: 0 0 30px;

    .heading {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
      text-transform: capitalize;
    }
  }

  .check-mark {
    display: block;
    text-transform: capitalize;

    input[type='checkbox'] {
      display: none;

      &:checked + .label-text:before {
        content: '\\e904';
      }
    }

    .label-text {
      display: block;
      position: relative;
      padding: 0 0 0 18px;
      cursor: pointer;

      &::before {
        display: flex;
        align-items: center;
        justify-content: center;
        content: '';
        font-family: icomoon;
        font-size: 7px;
        line-height: 1;
        position: absolute;
        top: 1px;
        left: 0;
        width: 14px;
        height: 14px;
        border-radius: 50px;
        border: 1px solid var(--white);
      }
    }
  }
`;

export const NotificationList = styled.div`
  height: 300px;
  overflow: auto;
  margin: 0 -10px 0 0;
  padding: 0 10px 0 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 30px;
    background: #1c1a42;
  }

  &::-webkit-scrollbar-thumb {
    background: #40ddff;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.03);
    border-radius: 30px;
  }
`;

export const ListBox = styled.div`
  width: 100%;
  padding: 20px;
  margin: 0 0 16px;
  border: 1px solid #40ddff;
  border-radius: 10px;

  .title {
    display: flex;
    align-items: center;
    gap: 3px;
    font-weight: 600;
    position: relative;
    margin: 0 0 15px;

    .ico {
      font-size: 15px;
    }
  }

  .list {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
    }

    .text {
      display: block;
      width: 135px;
      text-transform: capitalize;
    }
  }
`;
